/**
 * This file aims to provide a stripped down version of d3 that can be imported
 * in every file that needs its functions.
 */

import {
  scalePoint,
  scaleBand,
  scaleTime,
  scaleLinear,
  scaleOrdinal,
} from 'd3-scale';

import * as time from 'd3-time';
import * as shape from 'd3-shape';
import * as axis from 'd3-axis';
import * as selection from 'd3-selection'

import { timeFormat, utcFormat } from 'd3-time-format';

export default {
  scalePoint,
  scaleBand,
  scaleTime,
  scaleLinear,
  scaleOrdinal,
  ...shape,
  ...time,
  ...axis,
  ...selection,
  timeFormat,
  utcFormat,
};
